import { render } from "./domain-table.vue?vue&type=template&id=f087445e"
import script from "./domain-table.vue?vue&type=script&lang=js"
export * from "./domain-table.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__